import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
} from '@material-ui/core';
import FileIcon from '@material-ui/icons/Description';
import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useEffect, useState, useContext } from 'react';
import { AppContext } from '../../AppContext';
import cloneDeep from 'lodash.clonedeep';

// SERVICES
import { updateOrderLineServices, updateOrderLineDetails } from '../../services';
import { parseNumberInputValue } from '../../helpers';

const styles = theme => ({
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 20,
    '& > *': {
      alignSelf: 'stretch',
    },
  },
  dialogTitle: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  dialogActions: {
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e1e1e1',
  },
  cancelButton: {
    color: '#f44336',
  },
  removeButton: {
    color: '#f44336',
  },
  circularProgress: {
    padding: '6px 8px',
  },
  reportAttachmentList: {
    paddingLeft: 0,
    listStyle: 'none',
  },
  reportAttachmentListItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  fileLink: {
    display: 'flex',
    flexDirection: 'row',
  },
  uploadButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  errorMessage: { color: '#c33' },

  costTable: {
    width: '100%',

    '& td': {
      flex: 1,
      textAlign: 'left',
      position: 'relative',
    },

    '& tr': {
      marginBottom: 10,
    },

    '& th': {
      textAlign: 'left',
      fontWeight: 'bold',
    },

    '& > tr > *': {
      padding: 20,
    },

    '& > tr:last-of-type td': {
      borderTop: '2px solid #ccc',
    },
  },

  tableInput: {
    border: '1px solid #ccc',
    borderRadius: 5,
    padding: 10,
    paddingLeft: 25,
    fontSize: 16,
    // color: '#777',

    '&:focus': {
      outline: 'none',
    },
  },

  tableInputDollarSign: {
    position: 'absolute',
    top: 0,
    left: 30,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#777',
  },
});

export const ReportFees = withStyles(styles)(
  ({ classes, setOrder: updateOrder, order: initialOrderState, onClose }) => {
    const [files, setFiles] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState([]);
    const [order, setOrder] = useState(cloneDeep(initialOrderState));

    const {
      state: { roles },
      dispatch,
    } = useContext(AppContext);

    console.log({ roles })

    const validateQa = (roles) => {
      const isQA = roles.some(role => role === "QA")
      const isAdmin = roles.some(role => role === "SUPERADMIN" || role === "ADMIN")
      if (isAdmin) {
        return false
      }
      return isQA
    }

    const isQaRole = validateQa(roles)

    useEffect(() => {
      // setOrder(cloneDeep(initialOrderState));
      setOrder(
        cloneDeep({
          ...initialOrderState,
          orderLineDetail: initialOrderState.orderLineDetail.map((d, i) => ({
            ...d,
            // actualRevenue: d.actualRevenue || 100,
            // actualRevenue: 200,
          })),
        }),
      );
    }, [dialogOpen]);

    const saveFees = async () => {
      try {
        setSubmitting(true);

        await updateOrderLineServices(order.orderlineService);
        await updateOrderLineDetails(order.orderLineDetail);

        // update the order object in the parent
        updateOrder(order);

        // show success message
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            message: 'Fees updated!',
            variant: 'success',
          },
        });

        handleDialogClose();
      } catch (error) {
        // show error message
        dispatch({
          type: 'SET_SNACKBAR',
          snackbar: {
            isOpen: true,
            message: error.message || 'Fees failed to update',
            variant: 'error',
          },
        });
      }
      setSubmitting(false);
    };

    const handleDialogOpen = () => {
      setDialogOpen(true);
    };

    const handleDialogClose = () => {
      setDialogOpen(false);
      !!onClose && onClose();
    };

    const onChangeClient = evt => {
      const { value } = evt.target;

      const parsedValue = parseNumberInputValue(value);

      if (parsedValue === null || parsedValue < 0) {
        return;
      }

      const firstOrderLineIndexWithProductOrBundle =
        order.orderLineDetail.findIndex(({ productId, clientBundleId }) => !!productId || !!clientBundleId) || 0;
      const orderLineDetailTotal = order.orderLineDetail.reduce((acc, cur) => acc + (cur.actualRevenue || 0), 0);

      const diff = orderLineDetailTotal - parsedValue;

      const updatedOrderLineDetail = order.orderLineDetail.slice();
      const { actualRevenue } = updatedOrderLineDetail[firstOrderLineIndexWithProductOrBundle];
      updatedOrderLineDetail[firstOrderLineIndexWithProductOrBundle].actualRevenue = actualRevenue - diff;

      let updates = {
        // update the first index of order line detail since that is what we are displaying on the page
        orderLineDetail: updatedOrderLineDetail,
      };

      setOrder({
        ...order,
        ...updates,
      });
    };

    return (
      <React.Fragment>
        <MenuItem onClick={handleDialogOpen}>{isQaRole ? "View Fees" : "Edit Fees"}</MenuItem>

        <Dialog maxWidth="lg" open={dialogOpen} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
            {isQaRole ? "View Fees" : "Edit Fees"}
          </DialogTitle>
          <DialogContent>
            <main className={classnames('col-center-center', classes.container)}>
              <table className={classes.costTable}>
                <tr>
                  <th>SERVICE</th>
                  <th>FORM</th>
                  <th>FR PAYABLE ($)</th>
                  <th>QA PAYABLE ($)</th>
                  <th>CLIENT CHARGES ($)</th>
                </tr>

                {order.orderlineService
                  ? order.orderlineService.map((ols, olsIndex) => {
                    // figure out if it is field rep, qa, or client charge
                    const { territoryBased, userFulfilled } = ols.serviceType;
                    const isFieldRep = territoryBased && userFulfilled;
                    const isQa = !territoryBased && userFulfilled;
                    const isClientCharge = !territoryBased && !userFulfilled;
                    const { payableAmount } = ols;

                    const onChangeIndividual = evt => {
                      const { value } = evt.target;

                      const parsedValue = parseNumberInputValue(value);

                      if (parsedValue === null) {
                        return;
                      }

                      // make sure there is value length (there is no length if two decimal points are used)
                      // if (!value.length) {
                      //   return;
                      // }

                      // update the orderline service payabale amount
                      let updatedOrderlineService = order.orderlineService.slice();
                      updatedOrderlineService[olsIndex] = {
                        ...updatedOrderlineService[olsIndex],
                        // payableAmount: !!value.length ? floated : 0,
                        payableAmount: parsedValue,
                      };

                      setOrder({
                        ...order,
                        orderlineService: updatedOrderlineService,
                      });
                    };

                    const input = (
                      <input
                        className={classnames(classes.tableInput)}
                        value={payableAmount === null ? 0 : payableAmount.toString()}
                        onChange={onChangeIndividual}
                        type="number"
                        readOnly={isQaRole}
                      />
                    );

                    return (
                      <tr key={olsIndex}>
                        <td>{ols.serviceType.name}</td>
                        <td>{ols.formHeaderName}</td>
                        <td>
                          {isFieldRep && input ? <div className={classes.tableInputDollarSign}>$</div> : ''}
                          {isFieldRep && input}
                        </td>
                        <td>
                          {isQa && input ? <div className={classes.tableInputDollarSign}>$</div> : ''}
                          {isQa && input}
                        </td>
                        {/* <td>{isClientCharge && input}</td> */}
                      </tr>
                    );
                  })
                  : 'No data available...'}

                {/* Totals row */}
                <tr>
                  <td>TOTALS</td>
                  <td />
                  <td>
                    $
                    {order.orderlineService
                      .filter(
                        ols =>
                          parseFloat(ols.payableAmount) &&
                          ols.serviceType.territoryBased &&
                          ols.serviceType.userFulfilled,
                      )
                      .reduce((acc, cur) => acc + parseFloat(cur.payableAmount), 0)
                      .toFixed(2)}
                  </td>
                  <td>
                    $
                    {order.orderlineService
                      .filter(
                        ols =>
                          parseFloat(ols.payableAmount) &&
                          !ols.serviceType.territoryBased &&
                          ols.serviceType.userFulfilled,
                      )
                      .reduce((acc, cur) => acc + parseFloat(cur.payableAmount), 0)
                      .toFixed(2)}
                  </td>
                  <td>
                    <div className={classes.tableInputDollarSign}>$</div>
                    <input
                      className={classes.tableInput}
                      // value={order.orderLineDetail[0].actualRevenue === null ? 0 : order.orderLineDetail[0].actualRevenue}
                      value={order.orderLineDetail.reduce((acc, { actualRevenue }) => acc + (actualRevenue || 0), 0)}
                      onChange={onChangeClient}
                      type="number"
                      readOnly={isQaRole}
                    />
                  </td>
                </tr>
              </table>
            </main>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button color="secondary" onClick={handleDialogClose} disabled={submitting || loading}>
              {isQaRole ? "Close" : "Close & Discard Changes"}
            </Button>
            {!isQaRole && (
              <Button color="primary" onClick={saveFees} disabled={submitting || loading}>
                Save Updates
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  },
);

ReportFees.propTypes = {};
ReportFees.defaultProps = {};
